// TODO make some graphs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, Card, Banner } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json';
const propTypes = {
  product: PropTypes.object.isRequired,
  // seller: PropTypes.object.isRequired,
  order_supply: PropTypes.object.isRequired,
}

const SellerDashboard = (props) => (
  <AppProvider i18n={translations}>
    <Page
      fullWidth
    >
      <Card>
        <Banner title="Su cuenta necesita ser configurada" status="warning">
          <p>
            Su cuenta necesita ser configurada por un admin para tener acceso a la plataforma.
          </p>
        </Banner>
      </Card>
    </Page>
  </AppProvider>
);


SellerDashboard.propTypes = propTypes;

export default SellerDashboard;